export default __webpack_public_path__ + "static/media/worker-card-bg.d7c10e3a.svg";